import React from 'react';
import c from 'classnames';

import { useTranslation } from '@lyearn/i18n';
import { LoaderOutline, Plus } from '@lyearn/icons';
import { BaseButton } from '@lyearn/ui';

import { COMMON_BUTTON_STYLE } from '../utils';
import { BUTTON_CONFIG, buttonStyles, ICON_CONFIG, TYPOGRAPHY_CONFIG } from './styles';
import { AddBlockProps } from './types';

const labelClasses = (length: 'short' | 'long') => ({
  startIcon: c('m-0', ICON_CONFIG[length]),
  root: c('text-text-placeholder hover:text-text-secondary', TYPOGRAPHY_CONFIG[length]),
});

const SmallButton = React.forwardRef<HTMLButtonElement, AddBlockProps>((props, ref) => {
  const {
    length = 'long',
    startIcon = <Plus className="h-20 w-20 text-icon-placeholder" />,
    className,
    classes = labelClasses(length),
    title,
    disabled,
    loading,
    ...rest
  } = props;

  const { t } = useTranslation();

  if (loading) {
    return (
      <BaseButton
        ref={ref}
        className={c(COMMON_BUTTON_STYLE, buttonStyles, BUTTON_CONFIG[length], className)}
        classes={classes}
        disabled={Boolean(disabled)}
        startIcon={<LoaderOutline height={20} width={20} />}
        onClick={() => {}}
        {...rest}>
        {t('Journey:Builder.AddingPhase')}
      </BaseButton>
    );
  }

  return (
    <BaseButton
      ref={ref}
      className={c(COMMON_BUTTON_STYLE, buttonStyles, BUTTON_CONFIG[length], className)}
      classes={classes}
      disabled={Boolean(disabled)}
      startIcon={startIcon}
      {...rest}>
      {title}
    </BaseButton>
  );
});

export default React.memo(SmallButton);
export type { AddBlockProps };
